import React from "react";
import { Day } from "../types";

interface JournalViewProps {
  days: Day[];
}

export const JournalView: React.FC<JournalViewProps> = ({
  days,
}) => {
  // Get all days with notes, sorted by date (most recent first)
  const getDaysWithNotes = () => {
    return days
      .filter(day => day.notes && day.notes.trim() !== "")
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  };

  const allDaysWithNotes = getDaysWithNotes();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return "Today";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        month: "short",
        day: "numeric",
        year: date.getFullYear() !== today.getFullYear() ? "numeric" : undefined
      });
    }
  };

  return (
    <div style={{ paddingBottom: "60px" }}>
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ marginBottom: "16px" }}>Journal</h2>
        {allDaysWithNotes.length > 0 && (
          <div style={{ 
            fontSize: "14px", 
            color: "#666",
            marginBottom: "16px" 
          }}>
            {allDaysWithNotes.length} {allDaysWithNotes.length === 1 ? 'entry' : 'entries'} total
          </div>
        )}
      </div>

      {allDaysWithNotes.length === 0 ? (
        <div style={{
          textAlign: "center",
          padding: "40px 20px",
          color: "#666",
          fontSize: "16px"
        }}>
          <p>No journal entries found.</p>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            Start writing daily notes to see your journal timeline here.
          </p>
        </div>
      ) : (
        <div style={{ 
          display: "flex", 
          flexDirection: "column", 
          gap: "20px"
        }}>
          {allDaysWithNotes.map((day) => (
            <div
              key={day.date}
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #e9ecef"
              }}
            >
              <div style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#495057",
                marginBottom: "8px",
                fontFamily: "inherit"
              }}>
                {formatDate(day.date)}
              </div>
              <div style={{
                fontSize: "15px",
                lineHeight: "1.5",
                color: "#212529",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontFamily: "inherit"
              }}>
                {day.notes}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};